import { TitleHeader } from "./TitleHeader";

interface IProps {
  title: string;
  header: string;
  icon?: string;
  isReversed?: boolean;
}

export const TitleBar = ({ title, header, icon, isReversed }: IProps) => {
  return (
    <div>
      <div
        className={`md:flex w-full justify-between text-center ${
          isReversed
            ? "md:flex-row-reverse md:text-right"
            : "md:flex-row md:text-left"
        }`}
      >
        <TitleHeader title={title} header={header} />
        {icon && (
          <img
            className={"hidden lg:block lg:max-h-24"}
            src={icon}
            alt={"icon"}
          />
        )}
      </div>
      <hr className={"w-full mt-4 border-primary-800"} />
    </div>
  );
};
